import ChatModel from '../models/ChatModel';
import { CHAT_KEY_PREFIX } from '@src/Constants';
import NewMessageModel from '../models/NewMessageModel';
import ChatList from '@src/interfaces/ChatList';
import NewMessagesList from '@src/interfaces/NewMessagesList';
import { store } from '@src/store';

class ChatsResponse {
	public count: Number;
	public chats: ChatList;
	public newMessages: NewMessagesList;

	getUserType = () => {
		return store?.getState()?.currentUser?.value?.type;
	};

	generateChatId = (chat: any) => {
		// if (this?.getUserType() !== 'Restaurant') {
		// 	return CHAT_KEY_PREFIX + chat?.restaurantId + chat?.waId;
		// }
		return CHAT_KEY_PREFIX + chat.waId;
	};

	constructor(data: any) {
		let chats: ChatList = {};
		let newMessages: NewMessagesList = {};
		data?.results?.forEach((chatData: any) => {
			//data?.results
			// Chat
			const chat = new ChatModel(chatData);
			chats[this.generateChatId(chat)] = chat;
			// New messages
			const newWaId = chatData.contact.waba_payload.wa_id;
			const newAmount = chatData.new_messages;
			const prepared = new NewMessageModel(newWaId, newAmount);
			newMessages[CHAT_KEY_PREFIX + prepared?.waId] = prepared;
		});
		this.count = data.count;
		this.chats = chats;
		this.newMessages = newMessages;
	}
}

export default ChatsResponse;
